import m from "../../../../geodata/es2015/region/usa/neHigh";
window.am4geodata_region_usa_neHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/neHigh.js
// module id = null
// module chunks = 